import Header from "../../../sections/Header/Header";
import React from "react";
import Trial from "../../../sections/Bookfreetrial/Trial";
import Footer from "../../../sections/Footer/Footer";
import CoursesPicContBIK from "../../../sections/TitleBgCourses/CoursesPicContBIK/CoursesPicContBIK";
import TitleBgCoursesBIK from "../../../sections/TitleBgCourses/TitlepicCourses/TitleBgCoursesBIK/TitleBgCoursesBIK";
const CoursesBIK =()=>{
    return(
        <div>
            <Header/>
            <TitleBgCoursesBIK/>
            <CoursesPicContBIK/>
            
            <Trial/>
            <Footer/>
        </div>
    )
}
export default CoursesBIK;